import { AUTH, PRESCREENING, ROUTE } from '@/constants';
import { loadView } from '../index';

const PreScreeningDashboardView = loadView(
  'pre-screening/PreScreeningDashboardView',
);
const PreScreeningDetailKycView = loadView(
  'pre-screening/PreScreeningDetailKycView',
);
const PreScreeningVerifyKybView = loadView(
  'pre-screening/PreScreeningVerifyKybView',
);
const VerifyKybCDDView = loadView('pre-screening/verify-kyb/VerifyKybCDDView');
const VerifyKybDilisenseView = loadView(
  'pre-screening/verify-kyb/VerifyKybDilisenseView',
);
const VerifyKybDocsView = loadView(
  'pre-screening/verify-kyb/VerifyKybDocsView',
);
const VerifyKybFacecheckView = loadView(
  'pre-screening/verify-kyb/VerifyKybFacecheckView',
);
const VerifyKybSummaryView = loadView(
  'pre-screening/verify-kyb/VerifyKybSummaryView',
);
const PreScreeningVerifyKycView = loadView(
  'pre-screening/PreScreeningVerifyKycView',
);
const VerifyKycCDDView = loadView('pre-screening/verify-kyc/VerifyKycCDDView');
const VerifyKycDilisenseView = loadView(
  'pre-screening/verify-kyc/VerifyKycDilisenseView',
);
const VerifyKycDocsView = loadView(
  'pre-screening/verify-kyc/VerifyKycDocsView',
);
const VerifyKycFacecheckView = loadView(
  'pre-screening/verify-kyc/VerifyKycFacecheckView',
);
const VerifyKycSummaryView = loadView(
  'pre-screening/verify-kyc/VerifyKycSummaryView',
);

const preScreeningRoute = {
  path: ROUTE.PATH.PRE_SCREENING,
  component: () => import('@/layouts/default/DefaultLayout.vue'),
  meta: {
    auth: AUTH.USER_ROLE.AUTHORIZED,
    tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
  },
  children: [
    {
      path: '',
      name: ROUTE.NAME.PRE_SCREENING,
      component: PreScreeningDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: ROUTE.PATH.PRE_SCREENING_DASHBOARD,
      name: ROUTE.NAME.PRE_SCREENING_DASHBOARD,
      component: PreScreeningDashboardView,
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.PRE_SCREENING_DETAIL_KYC}/:id`,
      name: ROUTE.NAME.PRE_SCREENING_DETAIL_KYC,
      component: PreScreeningDetailKycView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
    },
    {
      path: `${ROUTE.PATH.PRE_SCREENING_VERIFY_KYB}/:id`,
      component: PreScreeningVerifyKybView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
      children: [
        {
          path: '',
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_CDD,
          component: VerifyKybCDDView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYB_CDD,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_CDD,
          component: VerifyKybCDDView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYB_DILISENSE,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_DILISENSE,
          component: VerifyKybDilisenseView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYB_DOCS,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_DOCS,
          component: VerifyKybDocsView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYB_FACECHECK,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_FACECHECK,
          component: VerifyKybFacecheckView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: `${ROUTE.PATH.PRE_SCREENING_VERIFY_KYB_SUMMARY}/:state`,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYB_SUMMARY,
          component: VerifyKybSummaryView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
      ],
    },
    {
      path: `${ROUTE.PATH.PRE_SCREENING_VERIFY_KYC}/:id`,
      component: PreScreeningVerifyKycView,
      props: (route) => ({ ...route.params }),
      meta: {
        auth: AUTH.USER_ROLE.AUTHORIZED,
        tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
      },
      children: [
        {
          path: '',
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_CDD,
          component: VerifyKycCDDView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYC_CDD,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_CDD,
          component: VerifyKycCDDView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYC_DILISENSE,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_DILISENSE,
          component: VerifyKycDilisenseView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYC_DOCS,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_DOCS,
          component: VerifyKycDocsView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: ROUTE.PATH.PRE_SCREENING_VERIFY_KYC_FACECHECK,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_FACECHECK,
          component: VerifyKycFacecheckView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
        {
          path: `${ROUTE.PATH.PRE_SCREENING_VERIFY_KYC_SUMMARY}`,
          name: ROUTE.NAME.PRE_SCREENING_VERIFY_KYC_SUMMARY,
          component: VerifyKycSummaryView,
          props: (route) => ({ ...route.params }),
          meta: {
            auth: AUTH.USER_ROLE.AUTHORIZED,
            tags: [PRESCREENING.APPROVAL_KEY.COMPLETED],
          },
        },
      ],
    },
  ],
};

export default preScreeningRoute;
